<template>
  <div class="comp-rz">
    <div class="icon">
      <router-link :to="`${$subsitePrefix}/innovation/sc-detail/${data.Id}`">
        <img @error="imgError" :src="data.Illustration" :alt="data.Headline" />
      </router-link>
    </div>
    <div class="name">{{ data.Headline }}</div>
    <div class="desc">
      <span class="field-left">描述：{{ data.Contents }}</span>
      <span :class="'field-right status-' + data.WorkFlowState">{{
        data.WorkFlowState | dictFilter
      }}</span>
    </div>
  </div>
</template>

<script>
export default {
  name: "sc-card",
  props: {
    data: {
      type: Object
    }
  },
  filters: {
    dictFilter(val) {
      if (val > 4 && val < 6) {
        return "公示中";
      }
      return "已结束";
      // return STATUS_MAP[val] || "";
    }
  }
};
</script>

<style lang="scss" scoped>
.comp-rz {
  width: 376px;
  height: 292px;
  background: rgba(255, 255, 255, 1);
  box-shadow: 0px 4px 12px 0px rgba(69, 80, 238, 0.08);
  border-radius: 8px;
  overflow: hidden;
  margin-bottom: 24px;
  margin-left: 24px;
  .icon {
    width: 376px;
    height: 176px;
    overflow: hidden;
    border-radius: 8px 8px 0 0;
    transition: all 0.3 ease;
  }
  .name {
    font-size: 18px;
    font-weight: 500;
    line-height: 22px;
    margin: 20px 24px 10px 24px;
    @include ellipsisc(2);
    height: 44px;
  }
  .desc {
    display: flex;
    justify-content: space-between;
    margin: 0 24px;
    .field-left {
      flex: 1;
      width: 0;
      overflow: hidden;
      white-space: nowrap;
      text-overflow: ellipsis;
      color: #999;
      strong {
        color: #ff6010;
        font-size: 16px;
      }
    }
    .field-right {
      color: #5cc7cf;
      position: relative;
      &::before {
        width: 4px;
        height: 4px;
        position: absolute;
        content: ' ';
        display: inline-block;
        overflow: hidden;
        left: -10px;
        top: 7px;
      }
    }
    .status-1 {
      color: #5cc7cf;
      &::before {
        background-color: #5cc7cf;
      }
    }
    .status-0 {
      color: #cccccc;
      &::before {
        background-color: #cccccc;
      }
    }
  }
  &:nth-child(3n-2) {
    margin-left: 0;
  }
  &:hover {
    box-shadow: 0px 4px 12px 0px rgba(69, 80, 238, 0.16);
  }
}
</style>
